"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CtaButton;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StickyDiv = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: sticky;\n  bottom: 0;\n  z-index: 100;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n"])));
function CtaButton() {
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(StickyDiv, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Block, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    text: "".concat(t('switch_plan')),
    appearance: "primary",
    width: "full",
    dataAttributes: {
      'data-testid': "pega-details-cta-button"
    }
  }))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    text: "".concat(t('switch_plan')),
    appearance: "primary",
    width: "full",
    dataAttributes: {
      'data-testid': "pega-details-cta-button"
    }
  })));
}